import { useState, useEffect } from "react";
import { Wifi, WifiOff, X } from "lucide-react";

/**
 * مكون إشعار حالة الاتصال
 * يظهر عندما يفقد المستخدم الاتصال أو يستعيده
 */
export const OfflineNotice = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showNotice, setShowNotice] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        setShowNotice(true);
        setTimeout(() => setShowNotice(false), 3000);
      }
      setWasOffline(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
      setShowNotice(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [wasOffline]);

  if (!showNotice) return null;

  return (
    <div className="fixed top-4 left-4 right-4 md:left-auto md:right-4 md:w-80 z-[9999] animate-in slide-in-from-top-2">
      <div className={`rounded-xl p-4 shadow-2xl flex items-center gap-3 ${
        isOnline 
          ? "bg-emerald-500 text-white" 
          : "bg-amber-500 text-white"
      }`}>
        {isOnline ? (
          <>
            <Wifi className="w-5 h-5" />
            <div className="flex-1">
              <p className="font-bold text-sm">تم استعادة الاتصال ✓</p>
              <p className="text-xs opacity-90">جاري مزامنة البيانات...</p>
            </div>
          </>
        ) : (
          <>
            <WifiOff className="w-5 h-5 animate-pulse" />
            <div className="flex-1">
              <p className="font-bold text-sm">لا يوجد اتصال بالإنترنت</p>
              <p className="text-xs opacity-90">التطبيق يعمل في وضع عدم الاتصال</p>
            </div>
          </>
        )}
        <button 
          onClick={() => setShowNotice(false)}
          className="p-1 hover:bg-white/20 rounded"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
